import React from 'react';
import { cn } from '../../lib/cn';
import { Icon } from '../Icon/Icon';
import type { IconKind } from '../Icon/Icon';

const labelClass = 'mb-2 block text-[10px] font-bold uppercase tracking-[0.16em] text-[var(--ink-3)]';
const fieldClass =
  'w-full rounded-[var(--r-sm)] border border-[var(--cream-2)] bg-[var(--cream-1)] py-[11px] text-sm text-[var(--ink-1)] outline-none transition focus:border-[var(--ai-4)] focus:shadow-[0_0_0_3px_rgba(91,141,239,0.15)]';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  icon?: IconKind;
  mono?: boolean;
  hint?: string;
  error?: string;
}

export function Input({ label, icon, mono, hint, error, className, ...props }: InputProps) {
  return (
    <div>
      {label ? <label className={labelClass}>{label}</label> : null}
      <div className="relative flex items-center">
        {icon ? (
          <Icon
            kind={icon}
            size={16}
            className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--ink-3)]"
          />
        ) : null}
        <input
          {...props}
          className={cn(
            fieldClass,
            icon ? 'pl-[42px] pr-4' : 'px-4',
            mono && 'font-[var(--font-mono)]',
            error && 'border-[var(--terracotta)]',
            className,
          )}
        />
      </div>
      {hint || error ? <div className={cn('mt-1.5 text-[11.5px]', error ? 'text-[var(--terracotta)]' : 'text-[var(--ink-3)]')}>{error ?? hint}</div> : null}
    </div>
  );
}
